import type React from 'react';
import { useCallback } from 'react';
import type { ConnectDragSource } from 'react-dnd';

type RefItem<T> = React.RefCallback<T> | React.MutableRefObject<T | null> | null | undefined;
export const useCombinedRef = <T extends Element>(...refs: (RefItem<T> | ConnectDragSource)[]) => {
    const refCb = useCallback((element: T | null) => {
        refs.forEach(ref => {
            if (!ref) {
                return;
            }

            if (typeof ref === 'function') {
                ref(element);
            } else {
                ref.current = element;
            }
        });
    }, refs);

    return refCb;
};
